/**
 * Extrai blocos de código com JSON de Chart.js para renderizar gráfico.
 * Suporta fences: ```chart, ```grafico, ```json e ```(sem linguagem).
 * O restante passa por Markdown.
 */
const CHART_FENCE =
  /```(?:chart|grafico|json)?\s*\n([\s\S]*?)```/gi

export function splitChatAssistantContent(body) {
  const text = body == null ? '' : String(body)
  if (!text.trim()) return [{ type: 'markdown', content: '' }]

  const segments = []
  let lastIndex = 0
  let match

  const re = new RegExp(CHART_FENCE.source, CHART_FENCE.flags)
  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({
        type: 'markdown',
        content: text.slice(lastIndex, match.index)
      })
    }
    const raw = (match[1] || '').trim()
    let spec = null
    try {
      spec = JSON.parse(raw)
    } catch {
      spec = null
    }
    const isChartSpec =
      spec &&
      typeof spec === 'object' &&
      !Array.isArray(spec) &&
      typeof spec.type === 'string' &&
      spec.data &&
      typeof spec.data === 'object'

    if (isChartSpec) {
      segments.push({ type: 'chart', spec })
    } else {
      segments.push({ type: 'markdown', content: match[0] })
    }
    lastIndex = re.lastIndex
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'markdown', content: text.slice(lastIndex) })
  }

  return segments.length ? segments : [{ type: 'markdown', content: text }]
}
